import { ReactNode, useState } from "react";
import { Layout } from "./Layout";
import { Home, Link as LinkIcon, Calendar, DollarSign, Users, CreditCard, Settings, ChevronDown, X, Menu } from "lucide-react";
import { useLocation, Link } from "wouter";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Sidebar } from "@/components/layout/Sidebar";
import logo from '@/assets/staymiddle-logo.png';

interface AgentLayoutProps {
  children: ReactNode;
}

export default function AgentLayout({ children }: AgentLayoutProps) {
  const [location] = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const navItems = [
    { label: "Dashboard", href: "/agent/dashboard", icon: <Home className="w-5 h-5 mr-2" />, active: location === "/agent/dashboard" },
    { label: "Property Links", href: "/agent/links", icon: <LinkIcon className="w-5 h-5 mr-2" />, active: location === "/agent/links" },
    { label: "Bookings", href: "/agent/bookings", icon: <Calendar className="w-5 h-5 mr-2" />, active: location === "/agent/bookings" },
    { label: "Commissions", href: "/agent/commissions", icon: <DollarSign className="w-5 h-5 mr-2" />, active: location === "/agent/commissions" },
    // { label: "Clients", href: "/agent/clients", icon: <Users className="w-5 h-5 mr-2" />, active: location === "/agent/clients" },
    { label: "Stripe Connect", 
        href: "/stripe-connect",
      icon: <CreditCard className="w-5 h-5 mr-2" />,
      active: location === "/stripe-connect"},
 
    { label: "Settings", href: "/settings", icon: <Settings className="w-5 h-5 mr-2" />, active: location === "/agent/settings" },
  ];

  return (
    <div className="flex min-h-screen">
      <Sidebar navItems={navItems} collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>{children}</Layout>
    </div>
  );
} 